import {baseApi} from '../api'
import {EndpointNameUsers} from '../../constants/endpoints'
import {RTKTagNames} from '../../constants/rtk-tag-names'

const UserExtendedEndpoints = baseApi.injectEndpoints({
  endpoints: build => ({
    getUser: build.query({
      query: () => ({
        url: EndpointNameUsers.GET_CURRENT_USER,
        method: 'GET',
      }),
      providesTags: [RTKTagNames.USER],
    }),
  }),
})

export const {useLazyGetUserQuery, useGetUserQuery} = UserExtendedEndpoints
